"use strict";

angular.module("core")
.component("invoicePrintButton", {
    controllerAs: "invoicePrintButtonCtrl",
    templateUrl: require("./invoice-print-button.component.html"),
    bindings: {
        invoiceId: "<",
        service: "<",
        showEmailButton: "<?",
        defaultPrintFormat: "<?"
    },
    controller: function(
        $rootScope, $scope, FlashBag, ModalService, gettextCatalog, IS_MOBILE, IS_MOBILE_APP,
        UserService, EmailInputModalService, ZebraPrinterService, InvoicePrintButtonService
    ) {
        var _this = this;
        UserService.isUserFetched().then(function onSuccess(user) {
            if (user) {
                $scope.dedicatedVendorId = user.dedicated_vendor_id;
            }
        });
        $scope.isMobile = IS_MOBILE;
        $scope.isMobileApp = IS_MOBILE_APP;
        $scope.isZebraPrinterSupported = ZebraPrinterService.isSupported();
        $scope.hasFavouritePrinter = ZebraPrinterService.hasFavouritePrinter;

        this.$onInit = function() {
            if (this.showEmailButton === undefined) {
                this.showEmailButton = true;
            }

            if (this.defaultPrintFormat === undefined) {
                this.defaultPrintFormat = InvoicePrintButtonService.PDF_LETTER_FORMAT;
            }
        }

        this.downloadDefaultFormatPDF = function() {
            $scope.isPrintButtonDisabled = true;
            InvoicePrintButtonService.downloadInvoicePDF(
                this.invoiceId,
                this.defaultPrintFormat,
                this.service
            ).finally(function() {
                $scope.isPrintButtonDisabled = false;
            });
        }

        this.downloadLetterPDF = function() {
            $scope.isPrintButtonDisabled = true;
            InvoicePrintButtonService.downloadInvoicePDF(
                this.invoiceId,
                InvoicePrintButtonService.PDF_LETTER_FORMAT,
                this.service
            ).finally(function() {
                $scope.isPrintButtonDisabled = false;
            });
        }

        this.downloadReceiptPDF = function() {
            $scope.isPrintButtonDisabled = true;
            InvoicePrintButtonService.downloadInvoicePDF(
                this.invoiceId,
                InvoicePrintButtonService.PDF_RECEIPT_FORMAT,
                this.service
            ).finally(function() {
                $scope.isPrintButtonDisabled = false;
            });
        }

        this.printReceiptPDF = function(forceSelectPrinter) {
            $scope.isPrintButtonDisabled = true;
            InvoicePrintButtonService.printReceiptPDF(
                this.invoiceId,
                this.service,
                forceSelectPrinter,
                $scope.dedicatedVendorId
            ).then(function onSuccess() {
                $scope.hasFavouritePrinter = true;
            }).finally(function() {
                $scope.isPrintButtonDisabled = false;
            });
        }

        this.emailLetterPDF = function() {
            EmailInputModalService.inputEmail(gettextCatalog.getString("Send invoice by email"))
            .then(function onSuccess(email) {
                $scope.isEmailButtonDisabled = true;
                _this.service.emailPDF(_this.invoiceId, "letter", email).$promise
                .then(function onSuccess(data) {
                    FlashBag.emailResult(data.email);
                }).finally(function() {
                    $scope.isEmailButtonDisabled = false;
                });
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/invoice-print-button/invoice-print-button.component.js
// module id = 525
// module chunks = 0